import { render, staticRenderFns } from "./postAudit.vue?vue&type=template&id=6baf1ce6&scoped=true&"
import script from "./postAudit.vue?vue&type=script&lang=js&"
export * from "./postAudit.vue?vue&type=script&lang=js&"
import style0 from "./postAudit.vue?vue&type=style&index=0&id=6baf1ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baf1ce6",
  null
  
)

export default component.exports